import { useStyles } from "./loading-button-styles";

type ColorLoad = | "AZUL" | "BRANCO"

interface Props {
    tipo: ColorLoad
}

export const LoadingButton = (props: Props) => {
    const classes = useStyles();
    const myClass = props.tipo === "AZUL" ? classes.loadAzul : classes.loadBranco

    return (
        <div className={`${classes.cLoader} ${myClass}`}></div>
    )
}
